import { List } from 'immutable';
import store from '../../reduxStore';
import { addFeatures, removeFeatures } from '../actions/features';

// Put these in an object so we can stub them in tests
var stubbableFunctions = {
  featureOn: function featureOn(featureName) {
    var features = store.getAppState().get('features', List());
    return features.includes(featureName);
  }
};
export function featureOn(featureName) {
  return stubbableFunctions.featureOn(featureName);
}
export function ifFeature(featureName, valueWith, valueWithout) {
  return featureOn(featureName) ? valueWith : valueWithout;
}
export function setFeatures(featuresList) {
  store.dispatch(addFeatures(featuresList));
}
export function unsetFeatures(featuresList) {
  store.dispatch(removeFeatures(featuresList));
}

// Usage: withTestFeatures(['feature'])
// 2nd argument lets your override the use of global sinon
// eslint-disable-next-line no-undef
export function withTestFeatures(featuresList) {
  var sinonToUse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : sinon;
  beforeEach(function () {
    sinonToUse.stub(stubbableFunctions, 'featureOn').callsFake(function (feature) {
      return featuresList.includes(feature);
    });
  });
  afterEach(function () {
    stubbableFunctions.featureOn.restore();
  });
}